import React from "react";
import styles from "../../styles/box-widget.module.scss";
import IconBoxWidgetPhone from "../../images/icon_box-widgets-phone.svg";
import IconBoxWidgetLine from "../../images/icon_box-widgets-line.svg";
import IconBoxWidgetWifiCalling from "../../images/icon_box-widgets-wifi_calling.svg";
import RegisterPC from "../../images/register_pc.svg";
import IconVdoCall from "../../images/vdo_call.svg";

import IconChatbot from "../../images/icon-chatbot.png";
import MainFunc from "../../models/MainFunc";
import MainData from "../../models/MainData";

import Modal from "react-bootstrap/Modal";
import IconModalCloseKbank from "../../images/close_modalQR.svg";
import IconModalClosePMIB from "../../images/close_modalQR.svg";
import QRCode from "react-qr-code";
import axios from "axios";
import moment from "moment";
import { QRCodeCanvas } from "qrcode.react";
class MyComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      device: "",
      browsers: "",
      openQR: false,
      botlineLink: "",
    };
  }
  componentDidMount() {
    this.setState({
      device: this.getMobileOperatingSystem(),
      browsers: this.detectBrowsers(),
    });
  }

  getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }
    return "";
  };

  detectBrowsers = () => {
    if (
      (navigator.userAgent.indexOf("Opera") ||
        navigator.userAgent.indexOf("OPR")) != -1
    ) {
      return "Opera";
    } else if (navigator.userAgent.indexOf("Edg") != -1) {
      return "Edge";
    } else if (
      navigator.userAgent.indexOf("Chrome") != -1 ||
      navigator.userAgent.indexOf("CriOS") != -1
    ) {
      return "Chrome";
    } else if (navigator.userAgent.indexOf("Safari") != -1) {
      return "Safari";
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
      return "Firefox";
    } else if (
      navigator.userAgent.indexOf("MSIE") != -1 ||
      !!document.documentMode == true
    ) {
      //IF IE > 10
      return "IE";
    } else {
      return "unknown";
    }
  };
  getQR = () => {
    this.setState({ botlineLink: "" });
    const headers = {
      Authorization: `Bearer ${MainData.initialData.bearerAuth}`,
      "language-locale": "th",
    };
    const data = {
      productId: MainData.initialData?.productId,
      planId: MainData.userSelectedData?.selectedPlan?.planId
        ? MainData.userSelectedData?.selectedPlan?.planId
        : MainData.screenSM002.planId,
      gender: MainData.dataBroker.gender
        ? MainData.screenSM001.gender
          ? MainData.screenSM001.gender
          : MainData.dataBroker.gender
        : MainData.screenSM001.gender
        ? MainData.screenSM001.gender
        : "",
      age:
        MainData.dataBroker?.birthdateQR?.length == 10
          ? MainData.screenSM001.birthdate?.length == 10
            ? moment().format("YYYY") -
              parseInt(MainFunc.getUserBirthDate("ac")?.split("-")[0])
            : moment().format("YYYY") -
              parseInt(MainFunc.getUserBirthDateQR("ac")?.split("-")[0])
          : MainData.screenSM001.birthdate?.length == 10
          ? moment().format("YYYY") -
            parseInt(MainFunc.getUserBirthDate("ac")?.split("-")[0])
          : null,
    };
    axios
      .post(MainData.serviceURL + "/Broker/GenBotLineLink", data, { headers })
      .then(async (response) => {
        // handle success
        if (this.state.device) {
          window.location.href = response.data.botlineLink;
        } else {
          this.setState({
            openQR: true,
            botlineLink: response.data.botlineLink,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        let errMsg = MainData.masterMessage.find(
          (x) => x.msgCode === "MSG1001"
        );
        this.props.errorAlert(
          true,
          !errMsg
            ? "พบปัญหาในการเชื่อมต่อไปยัง service กรุณาติดต่อผู้ดูแลระบบ"
            : errMsg.msgDescription.replace(
                "{{Service}}",
                error.response.data.data?.messageDescription
              ),
          " "
        );
        this.props.loadController(false);
      });
  };

  render() {
    return (
      <>
        <Modal
          show={this.state.openQR}
          size={"lg"}
          onHide={() => this.setState({ openQR: !this.state.openQR })}
          className={`${styles.modal} modalQR`}
        >
          {this.props.channel?.css && (
            <img
              className={`${styles.iconCloseModal}`}
              src={
                this.props.channel?.name == "KBANK"
                  ? IconModalCloseKbank
                  : IconModalClosePMIB
              }
              onClick={() => this.setState({ openQR: !this.state.openQR })}
            />
          )}
          <div className={styles.contentModal}>
            <div className={styles.contentModalBody}>
              <div
                className={styles.headerContact}
                dangerouslySetInnerHTML={{
                  __html: MainFunc.getLabelDtos("L0884"),
                }}
              ></div>
              <div
                className={styles.headerContact2}
                dangerouslySetInnerHTML={{
                  __html: MainFunc.getLabelDtos("L0885"),
                }}
              ></div>
              {this.state.botlineLink && (
                <div className={styles.qr}>
                  <QRCodeCanvas value={this.state.botlineLink} size={459} />
                </div>
              )}
            </div>
          </div>
        </Modal>
        <div
          className={`${styles.body} ${
            this.props.mainPage ? styles.mainPage : ""
          } ${this.props.isOpen ? styles.active : ""}`}
        >
          <a
            id="contact_linechat"
            target="_blank"
            onClick={() => {
              if (this.props.activePage) {
                MainFunc.sendDataToGTMKbank({
                  event: "track_event",
                  event_category: "chatbox",
                  event_label: "line_chat",
                  element_grouping: "icon",
                  element_section: "assistance",
                  element_title: MainFunc.getLabelDtos("L0786"),
                });
              } else {
                MainFunc.sendDataToGTMKbank({
                  event: "track_event",
                  event_category: "chatbox",
                  event_label: "line_chat",
                  element_grouping: "icon",
                  element_section: "assistance",
                  element_title: MainFunc.getLabelDtos("L0786"),
                });
              }
              this.getQR();
            }}
          >
            <div className={styles.line}>
              <img src={IconBoxWidgetLine} alt="icon-box-widget" />
              <div className={styles.lineText}>
                <div className={styles.lineTitle}>
                  <img src={IconChatbot} alt="icon-box-widget" />
                  <strong>
                    {MainFunc.getLabelDtos("L0785") /*Kbank Live*/}
                  </strong>
                </div>
                <div className={styles.lineSubTitle}>
                  <span>{MainFunc.getLabelDtos("L0786") /*Kbank Live*/}</span>
                </div>
              </div>
              <div className={styles.arrow} />
            </div>
          </a>
          <a
            id="contact_callkplus"
            target="_blank"
            onClick={() => {
              if (this.props.activePage) {
                MainFunc.sendDataToGTMKbank({
                  event: "track_event",
                  event_category: " link_click",
                  event_label: "wifi_calling_via_kplus",
                  element_grouping: "icon",
                  element_section: "assistance",
                  element_title: MainFunc.getLabelDtos("L0828").replace(
                    / /g,
                    "_"
                  ) /*โทรปรึกษาฟรีผ่าน K PLUS*/,
                });
              } else {
                MainFunc.sendDataToGTMKbank({
                  event: "track_event",
                  event_category: " link_click",
                  event_label: "wifi_calling_via_kplus",
                  element_grouping: "icon",
                  element_section: "assistance",
                  element_title: MainFunc.getLabelDtos("L0828").replace(
                    / /g,
                    "_"
                  ) /*โทรปรึกษาฟรีผ่าน K PLUS*/,
                });
              }
              if (this.state.device) {
                window.location.href = this.props.data?.contactWifiMb;
              } else {
                window.location.href = this.props.data?.contactWifiPc;
              }
            }}
          >
            <div className={styles.phone}>
              <img src={IconBoxWidgetWifiCalling} alt="icon-box-widget" />
              <div className={styles.phoneText}>
                <span>
                  {MainFunc.getLabelDtos("L0828") /*โทรปรึกษาฟรีผ่าน K PLUS*/}
                </span>
              </div>
              <div className={styles.arrow} />
            </div>
          </a>
          <a
            id={"contact_call24"}
            href={`tel:${this.props.data?.contactPhoneNumber}`}
            target="_blank"
            onClick={() => {
              if (this.props.activePage) {
                MainFunc.sendDataToGTMKbank({
                  event: "track_event",
                  event_category: " link_click",
                  event_label: "hotline_contact_center",
                  element_grouping: "icon",
                  element_section: "assistance",
                  element_title: MainFunc.getLabelDtos("L0783").replace(
                    / /g,
                    "_"
                  ),
                });
              } else {
                MainFunc.sendDataToGTMKbank({
                  event: "track_event",
                  event_category: " link_click",
                  event_label: "hotline_contact_center",
                  element_grouping: "icon",
                  element_section: "assistance",
                  element_title: MainFunc.getLabelDtos("L0783").replace(
                    / /g,
                    "_"
                  ),
                });
              }
            }}
          >
            <div className={styles.phone}>
              <img src={IconBoxWidgetPhone} alt="icon-box-widget" />
              <div className={styles.phoneText}>
                <span>
                  {MainFunc.getLabelDtos("L0783") /*02-8888888 กด 862*/}
                </span>
              </div>
              <div className={styles.arrow} />
            </div>
          </a>
          {MainData.screenDetail.vdoCallStatus && (
            <a
              id="contact_vdo-call"
              target="_blank"
              onClick={() => {
                if (this.props.activePage) {
                  MainFunc.sendDataToGTMKbank({
                    event: "track_event",
                    event_category: " link_click",
                    event_label: "vdo_call",
                    element_grouping: "icon",
                    element_section: "assistance",
                    element_title: MainFunc.getLabelDtos("L0895").replace(
                      / /g,
                      "_"
                    ),
                  });
                } else {
                  MainFunc.sendDataToGTMKbank({
                    event: "track_event",
                    event_category: " link_click",
                    event_label: "vdo_call",
                    element_grouping: "icon",
                    element_section: "assistance",
                    element_title: MainFunc.getLabelDtos("L0895").replace(
                      / /g,
                      "_"
                    ),
                  });
                }
                window.location.href = MainData.screenDetail.vdoCallUrl;
              }}
            >
              <div className={styles.phone}>
                <img src={IconVdoCall} alt="icon-box-widget" />
                <div className={styles.phoneText}>
                  <span>
                    {
                      MainFunc.getLabelDtos(
                        "L0895"
                      ) /*คุยกับเจ้าหน้าที่ (VDO Call)*/
                    }
                  </span>
                </div>
                <div className={styles.arrow} />
              </div>
            </a>
          )}
          {this.props.dataDropLead && (
            <a
              id={"contact_fill"}
              target="_blank"
              onClick={() => {
                if (this.props.activePage) {
                  MainFunc.sendDataToGTMKbank({
                    event: "track_event",
                    event_category: "anchor",
                    event_label: "contact_to_apply",
                    element_grouping: "icon",
                    element_section: "assistance",
                    element_title: MainFunc.getLabelDtos(
                      "L0886"
                    ) /*กรอกข้อมูล เพื่อให้ผู้เชี่ยวชาญติดต่อกลับ*/
                      .replace(/ /g, "_"),
                  });
                } else {
                  MainFunc.sendDataToGTMKbank({
                    event: "track_event",
                    event_category: "anchor",
                    event_label: "contact_to_apply",
                    element_grouping: "icon",
                    element_section: "assistance",
                    element_title: MainFunc.getLabelDtos(
                      "L0886"
                    ) /*กรอกข้อมูล เพื่อให้ผู้เชี่ยวชาญติดต่อกลับ*/
                      .replace(/ /g, "_"),
                  });
                }
                if (this.props.activePage) {
                  this.props.showDropLead();
                } else {
                  this.props.setActiveCompornent("isDropLead", false, true);
                }
              }}
            >
              <div className={styles.phone}>
                <img src={RegisterPC} alt="icon-box-widget" />
                <div className={styles.phoneText}>
                  <span>
                    {
                      MainFunc.getLabelDtos(
                        "L0886"
                      ) /*กรอกข้อมูล เพื่อให้ผู้เชี่ยวชาญติดต่อกลับ*/
                    }
                  </span>
                </div>
                <div className={styles.arrow} />
              </div>
            </a>
          )}
        </div>
      </>
    );
  }
}

export default MyComponent;
